/* eslint-disable @typescript-eslint/no-unused-vars */
/** @jsx jsx */

import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import FormContents from 'components/atoms/Form/FormContents';
import { css, jsx } from '@emotion/core';
import {
  Container, Row, Col,
} from 'react-grid-system';
import moment from 'moment';
import BodyText from 'components/atoms/BodyText';
import Button, { PrimaryButton, DeleteButton } from 'components/atoms/Button';
import ConfirmModal from 'components/organismos/ConfirmModal';
import TextForm from 'components/molecules/TextForm';
// import FormField from 'components/atoms/Form/FormField';
import BlockUI from 'components/molecules/BlockUi';
// import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
// import DatePickerForm from '../../../../molecules/DatePickerForm';
import ToastModal from '../../../../organismos/ToastModal';
import { TransferApplicationForm } from './hooks';
import FormPadding from 'components/atoms/Form/FormPadding';
// import LableTitle from 'components/atoms/LableTitle';
import FlexBox from 'components/atoms/FlexBox';
import { textFontSize, textColor, grayScale } from 'components/styles';
// import DataTable from 'components/organismos/DataTable/DataTable';
import CalendarForm from 'components/molecules/CalendarForm';
// import FormTitle from 'components/atoms/Form/FormTitle';
import HistoryApprovalTable from 'components/molecules/HistoryApprovalTable';
import AttendTransferModal from 'components/molecules/ChangeLogModal/Template/AttendTransferModal';
import TabControl from 'components/atoms/TabControl';
import FormHeader from 'components/templates/FormHeader';
import Calendar from 'components/molecules/CalendarV1';

const styles = {
  container: {
    marginTop: '30px'
  },
  tableContent: css({
    justifyContent: 'center',
    alignItems: 'center'
  }),
  colorText: css({
    color: grayScale.gray100,
  }),
  approvalWrap: css({
    padding: '0px',
    marginBottom: '15px',
    marginTop: '0px'
  }),
  formContent: {
    paddingBottom: "20px"
  }
};

const TransferApplicationPage: React.FC = () => {
  const history = useHistory();
  const {
    formik,
    targetDate,
    toastMessage,
    toastModalOpen,
    setToastModalOpen,
    confirmApplyModalOpen,
    closeConfirmApplyModal,
    isLoading,
    dispStaffName,
    isGetTransferSuccees,
    selectChangelog,
    setSelectChangelog,
    fetchChangeLogTransfer
  } = TransferApplicationForm();

  const WEEEK_DAY: Array<any> = ['日', '月', '火', '水', '木', '金', '土'];
  const columns: Array<any> = useMemo(() => [
    {
      Header: 'No',
      accessor: 'version',
    },
    {
      Header: '申請種別',
      id: 'modifiyStatus',
      accessor: 'modifiyStatus',
      Cell: (cell: { row: { isExpanded: boolean, original: any }, page: [] }) => {
        if (cell.row.original.modifiyStatus === 0) {
          return '申請';
        }
        if (cell.row.original.modifiyStatus === 1) {
          return '削除';
        }
        if (cell.row.original.modifiyStatus !== 0 && cell.row.original.modifiyStatus !== 1) {
          return '';
        }
      },
    },
    {
      Header: '申請日時	',
      id: 'applicationDate',
      accessor: 'applicationDate',
      Cell: (cell: { row: { isExpanded: boolean, original: any }, page: [] }) => {
        if (cell.row.original.applicationDate != null) {
          return moment(cell.row.original.applicationDate).format('YYYY/MM/DD HH:mm:ss');
        }
        if (cell.row.original.applicationDate == null) {
          return '';
        }
      },
    },
    {
      Header: '申請者	',
      id: 'applicationStaffCode',
      accessor: 'applicationStaffCode',
      Cell: (cell: { row: { isExpanded: boolean, original: any }, page: [] }) => {
        return (
          <span>
            <div>{cell.row.original.applicationStaffCode}<br></br>{cell.row.original.applicationStaffName}</div>
          </span>
        );
      },
    },
    {
      Header: '振替出勤日	',
      id: 'targetDate',
      accessor: 'targetDate',
      Cell: (cell: { row: { isExpanded: boolean, original: any }, page: [] }) => {
        if (cell.row.original.targetDate != null) {
          return moment(cell.row.original.targetDate).format('YYYY年MM月DD日') + '(' + WEEEK_DAY[moment(cell.row.original.targetDate).day()] + ')'
        }
        if (cell.row.original.targetDate == null) {
          return '';
        }
      },
    },
    {
      Header: '振替休日	',
      id: 'transferHolidayDate',
      accessor: 'transferHolidayDate',
      Cell: (cell: { row: { isExpanded: boolean, original: any }, page: [] }) => {
        if (cell.row.original.targetDate != null) {
          return moment(cell.row.original.transferHolidayDate).format('YYYY年MM月DD日') + '(' + WEEEK_DAY[moment(cell.row.original.transferHolidayDate).day()] + ')';
        }
        if (cell.row.original.targetDate == null) {
          return '';
        }
      },
    },
    {
      Header: '申請理由	',
      accessor: 'applicationReason',
    },
    {
      Header: '決裁状況	',
      id: 'applicationStatus',
      accessor: 'applicationStatus',
      Cell: (cell: { row: { isExpanded: boolean, original: any }, page: [] }) => {
        if (cell.row.original.applicationStatus === 0) {
          return '申請中';
        }
        if (cell.row.original.applicationStatus === 1) {
          return '承認';
        }
        if (cell.row.original.applicationStatus === 2) {
          return '差戻';
        }
        if (cell.row.original.applicationStatus !== 0 && cell.row.original.applicationStatus !== 1 && cell.row.original.applicationStatus !== 2) {
          return '';
        }
      },
    },
    {
      Header: '決裁日時	',
      id: 'approvalDate',
      accessor: 'approvalDate',
      Cell: (cell: { row: { isExpanded: boolean, original: any }, page: [] }) => {
        console.log(cell.row.original.approvalDate);
        if (cell.row.original.approvalDate != null) {
          return moment(cell.row.original.approvalDate).format('YYYY/MM/DD HH:mm:ss');
        }
        if (cell.row.original.approvalDate == null) {
          return ''
        }
      },
    },
    {
      Header: '差戻コメント',
      accessor: 'rejectReason',
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
  ], []);

  const sortBy = React.useMemo(
    () => [
      {
        id: 'no',
        desc: false,
      },
    ],
    [],
  );

  const [changeLogData, setChangeLogData] = useState<Array<any>>([]);

  useEffect(() => {
    if (formik.values.orgCode || formik.values.targetDate || formik.values.staffCode) {
      fetchChangeLogTransfer(formik.values.orgCode, formik.values.targetDateStr, formik.values.staffCode).then(res => {
        setChangeLogData(res);
      });
    }
  }, [formik.values.orgCode, formik.values.targetDate, formik.values.staffCode]);

  return (
    <SidebarTemplate pageTitle="振替申請">
      <BlockUI blocking={isLoading}>
      <FormHeader title="振替申請"/>
        <FormContents customStyle={css({marginTop:'60px'})}>
          <form onSubmit={formik.handleSubmit}>
            <Container fluid={true}>
              <FormPadding customStyle={css({paddingTop:'16px'})}>
                <Row>
                  <Col md={2} xs={12}>
                    <BodyText>日時</BodyText>
                  </Col>
                  <Col md={6} xs={12}>
                    <BodyText customStyle={styles.colorText}>
                      {moment(`${targetDate}`).format('YYYY年MM月DD日(ddd)')}
                    </BodyText>
                  </Col>
                </Row>
                </FormPadding>
                <FormPadding>
                <Row >
                  <Col md={2} xs={12}>
                    <BodyText>スタッフ</BodyText>
                  </Col>
                  <Col md={6} xs={12}>
                    <BodyText customStyle={styles.colorText}>
                      {dispStaffName}
                    </BodyText>
                  </Col>
                </Row>
                </FormPadding> 
                <FormPadding>
                <Row>
                  <Col md={2} xs={12} style={{display: 'flex', alignItems: 'center'}}>
                    <BodyText>振替休日</BodyText>
                  </Col>
                  <Col md={3} xs={12}>
                    <Calendar 
                      readOnly={formik.values.applicationStatus === 0}
                      date={moment(formik.values.transferHolidayDate).format('YYYYMMDD') === '19700101' ? new Date(targetDate) : formik.values.transferHolidayDate}
                      setDate={(date) => { 
                        if(date){
                          formik.setFieldValue('transferHolidayDate', date)
                        }
                       }}
                    />
                    {/* <CalendarForm
                      label=""
                      readOnly={formik.values.applicationStatus === 0}
                      date={moment(formik.values.transferHolidayDate).format('YYYYMMDD') === '19700101' ? new Date(targetDate) : formik.values.transferHolidayDate}
                      dateFormat='YYYY/MM/DD'
                      changeDate={(date: Date) => { formik.setFieldValue('transferHolidayDate', date); }} /> */}
                  </Col>
                </Row>
                </FormPadding>
                <FormPadding>
                  <Row >
                    <Col md={2} xs={12} style={{display: 'flex', alignItems: 'center'}}>
                      <BodyText>申請理由</BodyText>
                    </Col>
                    <Col md={6} xs={12}>
                      <TextForm
                        required={false}
                        name="applicationReason"
                        label=""
                        disable={formik.values.applicationStatus === 0}
                        value={String(formik.values.applicationReason)}
                        onChange={formik.handleChange}
                        errorMsg={formik.errors.applicationReason}
                      />
                    </Col>
                  </Row>
              </FormPadding>
              <Row>
                <Col md={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop:'8px' }}>
                  <div
                    css={css`
                  .btnAction:nth-of-type(2) {
                    margin-left: 10px;
                  }
                  .btnAction:nth-of-type(3) {
                    margin-left: 10px;
                  }
                `}>
                    <FlexBox>
                      {
                        (isGetTransferSuccees && (formik.values.modifiyStatus === null || formik.values.modifiyStatus === 0
                          || (formik.values.modifiyStatus === 1 && formik.values.applicationStatus !== 0))) && (
                          <div className="btnAction">
                            <PrimaryButton
                              ghost={false}
                              disabled={formik.values.applicationStatus === 0 && formik.values.createDate != null}
                              text="申請する"
                              onClick={() => {
                                formik.handleSubmit();
                                formik.setFieldValue('buttonType', 0);
                              }}
                            />
                          </div>
                        )
                      }
                      {
                        formik.values.applicationStatus === 0 && (
                          <div className="btnAction">
                            <DeleteButton
                              ghost={false}
                              text="申請キャンセル"
                              onClick={() => {
                                formik.handleSubmit();
                                formik.setFieldValue('buttonType', 1);
                              }}
                            />
                          </div>
                        )
                      }
                      {
                        formik.values.deleteAvailable === true && (
                          <div className="btnAction">
                            <DeleteButton
                              ghost={false}
                              text="削除申請"
                              onClick={() => {
                                formik.handleSubmit();
                                formik.setFieldValue('buttonType', 2);
                              }}
                            />
                          </div>
                        )
                      }

                    </FlexBox></div>
                </Col>
              </Row>
              <Row>
              <Col md={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' }}>
                <FlexBox>
                  <Button
                    onClick={() => history.goBack()}
                    text="キャンセル"
                    ghost={true}
                  />
                </FlexBox>
              </Col>
            </Row>
            </Container>
          </form>

          <ToastModal
            open={toastModalOpen}
            closeHandler={() => setToastModalOpen(false)}
            title={toastMessage}
          />

          <ConfirmModal
            open={confirmApplyModalOpen}
            closeHandler={closeConfirmApplyModal}
            onSubmit={formik.handleSubmit}
            // eslint-disable-next-line no-nested-ternary
            title={formik.values.buttonType === 0 ? (formik.values.modifiyStatus === 0 ? '振替修正を申請' : '振替を申請')
              : formik.values.buttonType === 1 ? '振替キャンセルを申請' : '削除振替を申請'}
            // eslint-disable-next-line no-nested-ternary
            content={formik.values.buttonType === 0 ? (formik.values.modifiyStatus === 0 ? '振替修正を申請します。よろしいですか？' : '振替を申請します。よろしいですか？')
              : formik.values.buttonType === 1 ? '振替キャンセルを申請します。よろしいですか？' : '削除振替を申請します。よろしいですか？'}
            // eslint-disable-next-line no-nested-ternary
            submitText='申請する'
            typeSubmit={formik.values.buttonType === 0 ? 'confirm' : 'reject'}
          />
        </FormContents>

      </BlockUI>

      <div style={{ paddingTop: 20 }}>
        <FormContents customStyle={styles.formContent}>
          <Row style={{ padding: "10px 15px" }}>
            <Col
              md={2}
              xs={12}
              style={{
                fontWeight: "bold",
                fontSize: textFontSize.md,
                lineHeight: "24px",
                paddingBottom: "20px",
                color: textColor.main
              }}>更新履歴</Col>
          </Row>
          <TabControl
            isTabModal={true}
            isFixed={false}
            items={changeLogData.map((log, index: number) => {
              return {
                value: String(index),
                display: `ver${log.version}`
              };
            })}
            setValue={setSelectChangelog as (arg: string) => void}
            currentValue={selectChangelog}
            styleNotActive={css({ borderRadius: 0, border: "none", width: "100px", flex: "unset" })}
            styleActive={css({
              borderRadius: 0,
              border: "none",
              borderBottom: "1px solid #007BC3",
              width: "100px",
              flex: "unset"
            })}
          />
          {changeLogData.length > 0 &&
            changeLogData.map((itemLog, index: number) => (
              <div style={{ display: selectChangelog !== String(index) ? "none" : "block" }}>
                <React.Fragment>
                  <FormPadding customStyle={{ fontSize: "14px", color: textColor.mobileTitle }}>
                    <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: "bold",
                          fontSize: textFontSize.re,
                          lineHeight: "24px",
                          paddingBottom: "20px",
                          color: textColor.main
                        }}>
                        申請種別:
                                            </Col>
                      <Col md={10} xs={12}>
                        {itemLog.modifiyStatus == 0 ? "申請" : "削除"}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: "bold",
                          fontSize: textFontSize.re,
                          lineHeight: "24px",
                          paddingBottom: "20px",
                          color: textColor.main
                        }}>
                        申請者:
                                            </Col>
                      <Col md={10} xs={12}>
                        {itemLog.applicationStaffCode && `${itemLog.applicationStaffCode} `}
                        {itemLog.applicationStaffName && itemLog.applicationStaffName}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: "bold",
                          fontSize: textFontSize.re,
                          lineHeight: "24px",
                          paddingBottom: "20px",
                          color: textColor.main
                        }}>
                        申請日時: </Col>
                      <Col md={10} xs={12}>
                        {itemLog.applicationDate && moment(itemLog.applicationDate).format("YYYY/MM/DD HH:mm:ss")}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: "bold",
                          fontSize: textFontSize.re,
                          lineHeight: "24px",
                          paddingBottom: "10px",
                          color: textColor.main
                        }}>
                        修正理由:
                                            </Col>
                      <Col md={10} xs={12}>
                        {itemLog.applicationReason && itemLog.applicationReason}
                      </Col>
                    </Row>

                    <Row>
                      <AttendTransferModal
                        changeLogData={[itemLog]}
                        selectChangelog={String(index)}
                        customStyle={styles.approvalWrap}
                      />
                    </Row>
                    <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: "bold",
                          fontSize: textFontSize.re,
                          lineHeight: "24px",
                          paddingBottom: "20px",
                          color: textColor.main
                        }}>
                        修正理由: </Col>
                      <Col md={10} xs={12}>
                        {itemLog.applicationReason && itemLog.applicationReason}
                      </Col>
                    </Row>
                    {changeLogData.length > 0 && (
                      <Row>
                        <HistoryApprovalTable
                          historyData={itemLog.approvalHistoryList}
                          applicationStatus={itemLog.applicationStatus}
                        />
                      </Row>
                    )}
                  </FormPadding>
                </React.Fragment>
              </div>
            ))}
        </FormContents>
      </div>
    </SidebarTemplate>
  );
};

export default TransferApplicationPage;
